<template>
  <div
    v-if="shouldShowStatementdogNews"
    class="container-statementdog-news"
  >
    <div class="statementdog-news-section-name">
      <h3>相關產業新聞</h3>
    </div>
    <div class="statementdog-news-list">
      <div
        v-for="item in newsList"
        :key="item.id"
        class="statementdog-news-list-item statementdog-news-list-item-grid"
        :data-news-id="item.id || item.feedable_id"
      >
        <a
          class="statementdog-news-list-item-news-thumbnail"
          target="_blank"
          :href="item.source_url"
          @click="() => clickNewsHandler({ targetUrl: item.source_url, title: item.title })"
        >
          <img
            loading="lazy"
            :src="item.thumbnail_url"
            :alt="item.title"
          >
        </a>
        <a
          class="statementdog-news-list-item-news-content"
          target="_blank"
          :href="item.source_url"
          @click="() => clickNewsHandler({ targetUrl: item.source_url, title: item.title })"
        >
          <div class="statementdog-news-list-item-news-content-text">
            <p class="title">
              {{ item.title }}
            </p>
            <p class="date">
              {{ formatDate(item.published_at) }}
            </p>
          </div>
        </a>
        <div
          v-if="item.related_tags.length > 0"
          class="statementdog-news-list-item-tags"
        >
          <ul class="statementdog-news-list-item-tags-list">
            <li
              v-for="tag in item.related_tags"
              :key="tag.name"
              class="statementdog-news-list-item-tags-list-item"
            >
              <a
                :href="tag.source_url"
                class="statementdog-news-list-item-tags-list-item-link"
                target="_blank"
                @click.stop="clickTagHandler(tag)"
              >{{ tag.name }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-if="shouldShowViewMoreButton || isLoading"
        class="statementdog-news-action-block"
      >
        <div
          v-if="shouldShowViewMoreButton"
          class="statementdog-news-view-more-button"
          @click="handleViewMoreNews"
        >
          查看更多產業要聞
        </div>
        <div
          v-if="isLoading"
          class="statementdog-news-loading-hint-block"
        >
          <CommonLoadingHint class="common-loading-hint-overwrite" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

import { CommonLoadingHint } from '@/modules/shared/components/CommonHint'

export default {
  name: 'ContainerStatementdogNews',
  components: {
    CommonLoadingHint,
  },
  props: {
    newsList: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    shouldShowViewMoreButton: {
      type: Boolean,
      default: false,
    },
    handleViewMoreNews: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      awsPersonalizeObserverDisconnectHandler: null,
    }
  },
  computed: {
    shouldShowStatementdogNews() {
      return !this.isEmptyContent
    },
    isEmptyContent() {
      return !this.isLoading && this.newsList.length === 0
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.awsPersonalizeObserverDisconnectHandler = window.observeNewsImpression({
        listElementSelector: '.statementdog-news-list',
        itemElementSelector: '.statementdog-news-list-item',
      })
    })
  },
  unmounted() {
    if (typeof this.awsPersonalizeObserverDisconnectHandler === 'function') {
      this.awsPersonalizeObserverDisconnectHandler()
    }
  },
  methods: {
    formatDate(timeString) {
      return dayjs(timeString).format('YYYY/MM/DD')
    },
    clickNewsHandler({ targetUrl, title }) {
      window.amplitudeEvents.clickStatementdogNews({
        medium: 'analysis_industry_news',
        targetUrl,
        title,
      })
    },
    clickTagHandler(tag) {
      window.amplitudeEvents.clickTag({
        medium: 'analysis_industry_news',
        tagName: tag.name,
        tagId: String(tag.id),
        targetUrl: tag.source_url,
      })
    },
  },
}
</script>

<style scoped lang="scss">
// 桌面版
@media screen and (min-width: 768px) {
  .container-statementdog-news {
    width: 100%;
  }
  .statementdog-news-section-name {
    border-bottom: 1px solid #dfdfdf;
    text-align: left;
    margin: 18px 0 21px;
    h3 {
      display: table;
      background-color: #ededed;
      margin: 0 9px -12px;
      padding: 0 9px;
      font-size: 18px;
      font-weight: bold;
      color: #434343;
    }
  }

  .statementdog-news-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .statementdog-news-list-item {
    text-align: left;
    width: 100%;
    padding: 15px 18px;
    background-color: #fff;
    border: 1px solid #dfdfdf;
    border-top-color: #e9e9e9;
    margin-bottom: -1px;
    box-sizing: border-box;
  }
  .statementdog-news-list-item-grid {
    display: grid;
    grid-template-columns: 120px 1fr;
    grid-template-rows: auto auto;
    grid-column-gap: 18px;

    .statementdog-news-list-item-news-thumbnail {
      grid-column: 1 / 2;
      grid-row: 1 / -1;
    }
    .statementdog-news-list-item-news-content {
      grid-column: 2 / -1;
      grid-row: 1;
    }
    .statementdog-news-list-item-tags {
      grid-column: 2 / -1;
      grid-row: 2;
    }
  }
  .statementdog-news-list-item-news-thumbnail {
    border-radius: 6px;
    width: 120px;
    height: 100px;
    overflow: hidden;
    transition: box-shadow 0.5s;

    &:hover {
      box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .statementdog-news-list-item-news-content {
    &:hover {
      cursor: pointer;

      .statementdog-news-list-item-news-content-text {
        .title {
          color: #0386f4;
          text-decoration: underline;
        }
      }
    }

    .statementdog-news-list-item-news-content-text {
      p {
        margin: 0;
      }
      .title {
        font-weight: 700;
        font-size: 18px;
        line-height: 165%;
      }
      .date {
        margin: 6px 0 7px;
        font-size: 15px;
        line-height: 165%;
      }
    }
  }
  .statementdog-news-list-item-tags {
    overflow: hidden;

    .statementdog-news-list-item-tags-list {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      text-align: left;
      height: 33px;
      overflow: hidden;

      .statementdog-news-list-item-tags-list-item {
        display: flex;
        border-radius: 3px;
        border: 1px solid #e3e3e3;
        max-width: 50%;
        height: 33px;
        box-sizing: border-box;
        color: #434343;

        @media screen and (min-width: 568px) {
          color: #838383;

          &:hover {
            color: #0386f4;
            border-color: #0386f4;
          }
        }

        a {
          display: inline-block;
          line-height: 1.425;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          color: inherit;
          font-size: 0.875rem;
          padding: 6px 12px;
          @media screen and (min-width: 568px) {
            height: 21px;
            line-height: 1.65;
            font-size: 0.8125rem;
          }
        }
      }
    }
  }
  .statementdog-news-action-block {
    width: 100%;
    border: 1px solid #dfdfdf;
    border-top-color: #e9e9e9;
    background-color: #fff;
    padding: 15px 18px;

    .statementdog-news-view-more-button {
      font-size: 15px;
      font-weight: bold;
      color: #0386f4;
      text-align: center;
      cursor: pointer;
      margin: auto;
    }
  }
}
// 手機版
@media screen and (max-width: 768px) {
  a {
    text-decoration: none;
  }
  h3, p {
    margin: 0;
  }
  .container-statementdog-news {
    background-color: #fff;
    overflow: hidden;
  }
  .statementdog-news-section-name {
    padding: 1rem;
    padding-top: 1.5rem;

    h3 {
      font-size: 1.5rem;
      font-weight: bold;
    }
  }
  .statementdog-news-list-item {
    padding: 1rem;
    border-top: 1px solid #dfdfdf;
  }
  .statementdog-news-list-item-grid {
    display: grid;
    grid-template-columns: 90px 1fr;
    grid-template-rows: auto auto;
    grid-column-gap: 16px;

    .statementdog-news-list-item-news-thumbnail {
      grid-column: 1 / 2;
      grid-row: 1 / -1;
    }
    .statementdog-news-list-item-news-content {
      grid-column: 2 / -1;
      grid-row: 1;
    }
    .statementdog-news-list-item-tags {
      grid-column: 2 / -1;
      grid-row: 2;
    }
  }
  .statementdog-news-list-item-news-content {
    .statementdog-news-list-item-news-content-text {
      .title {
        font-weight: 700;
        font-size: 1.125rem;
        line-height: 165%;
        color: #434343;
      }
      .date {
        margin-top: 10px;
        font-size: 0.875rem;
        line-height: 165%;
        color: #434343;
      }
    }
  }
  .statementdog-news-list-item-news-thumbnail {
    border-radius: 6px;
    width: 90px;
    height: 90px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .statementdog-news-list-item-tags {
    margin-top: 8px;

    .statementdog-news-list-item-tags-list {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      text-align: left;
      height: 33px;
      overflow: hidden;
      margin: 0;
      padding: 0;

      .statementdog-news-list-item-tags-list-item {
        display: flex;
        border-radius: 3px;
        border: 1px solid #e3e3e3;
        max-width: 50%;
        height: 33px;
        box-sizing: border-box;
        color: #434343;

        @media screen and (min-width: 568px) {
          color: #838383;

          &:hover {
            color: #0386f4;
            border-color: #0386f4;
          }
        }

        a {
          display: inline-block;
          line-height: 1.425;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          color: inherit;
          font-size: 0.875rem;
          padding: 6px 12px;
          @media screen and (min-width: 568px) {
            height: 21px;
            line-height: 1.65;
            font-size: 0.8125rem;
          }
        }
      }
    }
  }
  .statementdog-news-action-block {

    .statementdog-news-view-more-button {
      margin: 1rem 1rem 1.5rem;
      display: block;
      text-align: center;
      border: 1px solid #0386f4;
      border-radius: 6px;
      color: #fff;
      font-size: 1rem;
      font-weight: 700;
      padding: 0.75rem 0;
      background-color: #0386f4;
      text-decoration: none;
    }
  }

  .statementdog-news-loading-hint-block {
    margin: 1rem 0;
  }
}
</style>
